// Colorado State University's undergraduate majors (#2743). Read on
// 2026-10-01 from the official 2026-2027 General Catalog
// (catalog.colostate.edu): each college page's "Undergraduate Majors" list,
// grouped by that college. Degrees: the list names one only for Art (B.A.,
// B.F.A.), Dance (B.A., B.F.A.), Music (B.A., B.M.) and the Biomedical
// Engineering dual-degree programs (each "(B.S.) combined with ... (B.S.)");
// Business Administration carries B.S. because the catalog says the College
// of Business "offers only one degree: a Bachelor of Science in Business
// Administration" (also on the Competitive Majors page). Every other major is
// `degree: null`. Left out: the College of Business's twelve concentrations
// and Neuroscience's two (listed under the majors, but concentrations), the
// generic "Biomedical Engineering" link (an index of the five dual-degree
// programs, which are listed), minors, certificates and graduate programs.
// "Major in" is dropped from names. The KB's majors list was the starting
// point; the catalog wins.
const majors = {
    "slug": "colorado-state-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in CSU's official 2026-2027 General Catalog, grouped by the college that offers it. The catalog's college pages name a degree only where a major comes in more than one (Art, Dance, Music) or is a combined program; elsewhere no degree is shown. Concentrations, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agricultural Sciences",
            "source": {
                "label": "CSU 2026-2027 General Catalog, College of Agricultural Sciences",
                "url": "https://catalog.colostate.edu/general-catalog/colleges/agricultural-sciences/"
            },
            "majors": [
                {
                    "name": "Agricultural Biology",
                    "degree": null
                },
                {
                    "name": "Agricultural Business",
                    "degree": null
                },
                {
                    "name": "Agricultural Education",
                    "degree": null
                },
                {
                    "name": "Animal Science",
                    "degree": null
                },
                {
                    "name": "Environmental and Natural Resource Economics",
                    "degree": null
                },
                {
                    "name": "Environmental Horticulture",
                    "degree": null
                },
                {
                    "name": "Equine Science",
                    "degree": null
                },
                {
                    "name": "Horticulture",
                    "degree": null
                },
                {
                    "name": "Landscape Architecture",
                    "degree": null
                },
                {
                    "name": "Livestock Business Management",
                    "degree": null
                },
                {
                    "name": "Soil and Crop Sciences",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "CSU 2026-2027 General Catalog, College of Business",
                "url": "https://catalog.colostate.edu/general-catalog/colleges/business/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Walter Scott, Jr. College of Engineering",
            "source": {
                "label": "CSU 2026-2027 General Catalog, Walter Scott, Jr. College of Engineering",
                "url": "https://catalog.colostate.edu/general-catalog/colleges/engineering/"
            },
            "majors": [
                {
                    "name": "Chemical and Biological Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Construction Engineering",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Environmental Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                },
                {
                    "name": "Biomedical Engineering combined with Chemical and Biological Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering combined with Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering combined with Electrical Engineering, Electrical Engineering Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering combined with Electrical Engineering, Lasers and Optical Engineering Concentration",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering combined with Mechanical Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Health and Human Sciences",
            "source": {
                "label": "CSU 2026-2027 General Catalog, College of Health and Human Sciences",
                "url": "https://catalog.colostate.edu/general-catalog/colleges/health-human-sciences/"
            },
            "majors": [
                {
                    "name": "Apparel and Merchandising",
                    "degree": null
                },
                {
                    "name": "Construction Management",
                    "degree": null
                },
                {
                    "name": "Early Childhood Education",
                    "degree": null
                },
                {
                    "name": "Family and Consumer Sciences Education",
                    "degree": null
                },
                {
                    "name": "Fermentation and Food Science",
                    "degree": null
                },
                {
                    "name": "Health and Exercise Science",
                    "degree": null
                },
                {
                    "name": "Hospitality and Event Management",
                    "degree": null
                },
                {
                    "name": "Human Development and Family Studies",
                    "degree": null
                },
                {
                    "name": "Interior Architecture and Design",
                    "degree": null
                },
                {
                    "name": "Nutrition Science",
                    "degree": null
                },
                {
                    "name": "Social Work",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "CSU 2026-2027 General Catalog, College of Liberal Arts",
                "url": "https://catalog.colostate.edu/general-catalog/colleges/liberal-arts/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Ethnic Studies",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "International Studies",
                    "degree": null
                },
                {
                    "name": "Journalism and Media Communication",
                    "degree": null
                },
                {
                    "name": "Languages, Literatures, and Cultures",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Liberal Arts",
                    "degree": null
                }
            ]
        },
        {
            "name": "Warner College of Natural Resources",
            "source": {
                "label": "CSU 2026-2027 General Catalog, Warner College of Natural Resources",
                "url": "https://catalog.colostate.edu/general-catalog/colleges/natural-resources/"
            },
            "majors": [
                {
                    "name": "Conservation and Environmental Leadership",
                    "degree": null
                },
                {
                    "name": "Ecosystem Science and Sustainability",
                    "degree": null
                },
                {
                    "name": "Fire and Emergency Services Administration",
                    "degree": null
                },
                {
                    "name": "Fish, Wildlife, and Conservation Biology",
                    "degree": null
                },
                {
                    "name": "Forest and Rangeland Stewardship",
                    "degree": null
                },
                {
                    "name": "Geosciences",
                    "degree": null
                },
                {
                    "name": "Natural Resources Management",
                    "degree": null
                },
                {
                    "name": "Restoration Ecology",
                    "degree": null
                },
                {
                    "name": "Watershed Science and Sustainability",
                    "degree": null
                },
                {
                    "name": "Geology",
                    "degree": null
                },
                {
                    "name": "Human Dimensions of Natural Resources",
                    "degree": null
                },
                {
                    "name": "Natural Resource Tourism",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Natural Sciences",
            "source": {
                "label": "CSU 2026-2027 General Catalog, College of Natural Sciences",
                "url": "https://catalog.colostate.edu/general-catalog/colleges/natural-sciences/"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biological Science",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Natural Sciences",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null
                },
                {
                    "name": "Zoology",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Veterinary Medicine and Biomedical Sciences",
            "source": {
                "label": "CSU 2026-2027 General Catalog, College of Veterinary Medicine and Biomedical Sciences",
                "url": "https://catalog.colostate.edu/general-catalog/colleges/veterinary-medicine-biomedical-sciences/"
            },
            "majors": [
                {
                    "name": "Biomedical Sciences",
                    "degree": null
                },
                {
                    "name": "Environmental Public Health",
                    "degree": null
                },
                {
                    "name": "Health Physics",
                    "degree": null
                },
                {
                    "name": "Medical Microbiology and Infectious Disease",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
